import React from "react";
import {Config} from '../Config';
import {NavLink} from "react-router-dom";
import IconMap from "../img/icons/icon-map.svg";
import IconMail from "../img/icons/icon-mail.svg";
import IconYoutube from "../img/icons/icon-youtube.svg";
import IconFacebook from "../img/icons/icon-facebook.svg";
import IconTwitter from "../img/icons/icon-twitter-2.svg";
import IconInstagram from "../img/icons/icon-instagram.svg";
import IconLinkedin from "../img/icons/icon-linkedin.svg";

export default function NotFound(prop) {
    let [data, setData] = React.useState(null);

    React.useEffect(() => {
    }, []);

    return (
        <>
            <div className="section">
                <div className="container py-5 text-center">
                    <h1>Error 404 Not Found</h1>
                    <h2>ขออภัยไม่พบหน้าที่ต้องการ</h2>
                </div>

            </div>
        </>
    );
} 